import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import { updatePerson } from "../../apeople";



const normalize = (p) => ({
  type: p?.type || "Doctor",
    title: p?.title || "Dr",
  firstName: p?.firstName || "",
  lastName: p?.lastName || "",
  bhfNumber: p?.bhfNumber || "",
  hpcsaNumber: p?.hpcsaNumber || "",
});

export function EditPersonInline({
  personId,
  initialValue,
  onHide = () => {},
  onPeopleUpdate = () => {},
}) {
  const [person, setPerson] = useState(normalize(initialValue));
  const [errors, setErrors] = useState({});
  const [successAlert, setSuccessAlert] = useState(false);

  useEffect(() => {
    setPerson(normalize(initialValue));
  }, [initialValue]);

  const validateForm = () => {
    const e = {};
    if (!person.type) e.type = "Type is required.";
    if (!person.firstName) e.firstName = "First name is required.";
    if (!person.lastName) e.lastName = "Last name is required.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPerson((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  try {
    const token = sessionStorage.getItem("user");
    if (!token) throw new Error("User not authenticated");

    const payload = {
      type: person.type,
        title: person.title,
      firstName: person.firstName,
      lastName: person.lastName,
      bhfNumber: person.bhfNumber,
      hpcsaNumber: person.hpcsaNumber,
    };

    await updatePerson(personId, payload, token);

    setSuccessAlert(true);

    setTimeout(() => {
      setSuccessAlert(false);
      onPeopleUpdate();  // reload list
      onHide();          // exit edit mode
    }, 700);
  } catch (error) {
    console.error("❌ Error updating person:", error);
  }
};


  return (
    <Form onSubmit={handleSubmit} className="p-2">
      {successAlert && (
        <Alert variant="success" className="w-100 fs-6 fw-normal py-2">
          Person updated successfully!
        </Alert>
      )}

      <Row className="mb-3">
        <Form.Group as={Col} md={4} controlId="type">
          <Form.Label>Type</Form.Label>
          <Form.Select
            name="type"
            value={person.type}
            isInvalid={!!errors.type}
            onChange={handleChange}
          >
            <optgroup label="Medical Practitioners">
              <option value="GP">General Practitioner (GP)</option>
              <option value="Cardio">Cardiologist</option>
              <option value="Derm">Dermatologist</option>
              <option value="Endo">Endocrinologist</option>
              <option value="Gastro">Gastroenterologist</option>
              <option value="Neuro">Neurologist</option>
              <option value="Onco">Oncologist</option>
              <option value="Ortho">Orthopaedic Surgeon</option>
              <option value="Pead">Paediatrician</option>
            <option value="Phys">Physician</option>
              <option value="Psych">Psychiatrist</option>
              <option value="Pulmo">Pulmonologist</option>
            </optgroup>

            <optgroup label="Surgical & Diagnostic Specialists">
              <option value="ENT">ENT Specialist</option>
              <option value="Eye">Ophthalmologist</option>
              <option value="Radio">Radiologist</option>
              <option value="Patho">Pathologist</option>
            </optgroup>

            <optgroup label="Allied Health Professionals">
              <option value="Physio">Physiotherapist</option>
              <option value="OT">Occupational Therapist</option>
              <option value="Biokineticist">Biokineticist</option>
              <option value="Dietician">Dietitian</option>
              <option value="Speech">Speech Therapist</option>
              <option value="Audio">Audiologist</option>
              <option value="Psychologist">Clinical Psychologist</option>
              <option value="Chiro">Chiropractor</option>
              <option value="Podiatrist">Podiatrist</option>
            </optgroup>

            <optgroup label="Nursing & Pharmacy">
              <option value="Nurse">Nurse</option>
              <option value="Pharma">Pharmacist</option>
            </optgroup>

            <optgroup label="Dental">
              <option value="Dentist">Dentist</option>
            </optgroup>

            <option value="Other">Other</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.type}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} md={2} controlId="type">
          <Form.Label>Type</Form.Label>
          <Form.Select
            name="title"
            value={person.title}
            onChange={handleChange}
          >
            <option value="Dr">Dr</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
            <option value="Miss">Miss</option>
            <option value="Prof">Prof</option>
          </Form.Select>
        </Form.Group>

        <Form.Group as={Col} md={4} controlId="firstName">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            name="firstName"
            value={person.firstName}
            isInvalid={!!errors.firstName}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {errors.firstName}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md={4} controlId="lastName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            name="lastName"
            value={person.lastName}
            isInvalid={!!errors.lastName}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {errors.lastName}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} md={6} controlId="bhfNumber">
          <Form.Label>BHF #</Form.Label>
          <Form.Control
            name="bhfNumber"
            value={person.bhfNumber}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group as={Col} md={6} controlId="hpcsaNumber">
          <Form.Label>HPCSA #</Form.Label>
          <Form.Control
            name="hpcsaNumber"
            value={person.hpcsaNumber}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      <div className="d-flex gap-2 mt-3">
        <Button variant="primary" className="px-4" type="submit">
          <FaUpload className="me-2" />
          Submit
        </Button>
        <Button
          variant="outline-secondary"
          className="px-4"
          type="button"
          onClick={onHide}
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
}
